import React from "react";

const ServicesMiniSection = () => {
  return (
    <section className="relative py-10  w-full overflow-hidden flex items-center justify-center">
      {/* 1. Background Image with Blur (Scale prevents white edges) */}
      <div
        className="absolute inset-0 bg-cover bg-center blur-sm scale-110 transform"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1952&q=80')",
        }}
      ></div>

      {/* 2. Dark Overlay (Ensures text is readable on all screens) */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]"></div>

      {/* 3. Content Container */}
      <div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center">
        {/* 
           Typography:
           - text-3xl: Mobile (Small screens)
           - sm:text-5xl: Tablets
           - lg:text-7xl: Desktop/Large screens
        */}
        <h1 className="text-3xl sm:text-5xl lg:text-7xl font-extrabold text-white tracking-tight drop-shadow-xl mb-6">
          Explore the <span className="text-blue-600">Unknown</span>
        </h1>

        {/*                 
           Description:
           - text-base: Mobile
           - sm:text-lg: Tablet
           - lg:text-2xl: Desktop
        */}
        <p className="mt-4 text-base sm:text-lg lg:text-2xl text-gray-200 font-light leading-relaxed drop-shadow-lg">
          Embark on a journey through technology and innovation. We provide
          cutting-edge solutions that transform your ideas into reality with
          precision.
        </p>

        {/* 
           Responsive Buttons:
           - flex-col: Stack vertically on Mobile
           - sm:flex-row: Sit side-by-side on Tablet/Desktop
           - w-full sm:w-auto: Buttons take full width on mobile, auto on desktop
        */}
        {/* <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
          <button className="w-full sm:w-auto px-8 py-4 bg-blue-600 hover:bg-white text-white hover:text-black text-lg font-bold rounded-full shadow-lg shadow-cyan-500/40 transition-all transform hover:-translate-y-1">
            Get Started
          </button>

          <button className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white text-lg font-bold rounded-full transition-all">
            Learn More
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default ServicesMiniSection;
